import React from 'react'
import List from './List';

const Examples = () => {
  return (
    <section className='section-second'>
      <div className='box relative box-second'>
        <List />
        <span className='absolute -top-[60px]' id='examples'></span>
      </div>
    </section>
  );
}

export default Examples
